import { render, staticRenderFns } from "./Quantity.vue?vue&type=template&id=79672d87&scoped=true&"
import script from "./Quantity.vue?vue&type=script&lang=ts&"
export * from "./Quantity.vue?vue&type=script&lang=ts&"
import style0 from "./Quantity.vue?vue&type=style&index=0&id=79672d87&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79672d87",
  null
  
)

export default component.exports